import type { TranslationTree } from '../../types';

export const adminTools: TranslationTree = {
  adminTools: {
    tab: 'Tool deletion',
    title: 'Tool administration',
    subtitle:
      'Delete tools or whole references for your company. Deletions are permanent and remove the machining traces of each deleted tool.',
    loading: 'Loading tools…',
    summary: {
      references: '{{count}} references',
      tools: '{{count}} tools',
      unreferenced: '{{count}} unreferenced tools',
    },
    group: {
      count: '{{count}} tools',
      alias: 'alias: “{{alias}}”',
    },
    unreferenced: {
      title: 'Unreferenced tools — deletable one by one only',
    },
    dates: {
      line: 'created {{created}} · updated {{updated}}',
      none: 'no traces',
    },
    actions: {
      deleteTool: 'Delete',
      deleteReference: 'Delete reference',
      retry: 'Retry',
    },
    dialog: {
      cancel: 'Cancel',
      tool: {
        title: 'Delete tool {{toolId}}?',
        description:
          'This deletes the tool {{toolId}} and all of its machining traces. This cannot be undone.',
        confirm: 'Delete tool',
      },
      reference: {
        title: 'Delete reference {{reference}}?',
        description:
          'This deletes the {{count}} tools of reference {{reference}}, all of their machining traces, and the reference alias. This cannot be undone.',
        descriptionAliasOnly:
          'Reference {{reference}} has no tools — this deletes its alias entry. This cannot be undone.',
        confirm: 'Delete reference',
      },
    },
    error: {
      generic: 'The deletion failed. Please try again.',
    },
  },
};
